import { graphql, useStaticQuery } from "gatsby";
import { KontentMediaImage, KontentPageMetadata } from "../types";

interface KontentHomePageMetadata {
  allKontentItemHomepage: {
    edges: {
      node: {
        id: string;
        elements: {
          content: {
            value: {
              elements: KontentPageMetadata;
            }[];
          };
        };
      };
    }[];
  };
}

interface InheritableSeoData {
  pageDescription?: string;
  socialShareImage?: KontentMediaImage;
  socialShareDescription?: string;
  socialShareTitle?: string;
}

export const useHomePageMetadata = (): InheritableSeoData => {
  const homePageData = useStaticQuery<KontentHomePageMetadata>(graphql`
    {
      allKontentItemHomepage {
        edges {
          node {
            id
            elements {
              content {
                value {
                  ... on kontent_item_content___page {
                    id
                    elements {
                      page_metadata__page_description {
                        value
                      }
                      page_metadata__social_share_image {
                        value {
                          ...kontentMediaImage
                        }
                      }
                      page_metadata__social_share_description {
                        value
                      }
                      page_metadata__social_share_title {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const homeElements =
    homePageData?.allKontentItemHomepage?.edges[0].node.elements?.content
      ?.value[0].elements;

  const pageDescription = homeElements?.page_metadata__page_description?.value;
  return {
    pageDescription: pageDescription,
    socialShareImage: homeElements?.page_metadata__social_share_image?.value[0],
    socialShareDescription:
      homeElements?.page_metadata__social_share_description?.value ||
      pageDescription,
    socialShareTitle: homeElements?.page_metadata__social_share_title?.value,
  };
};
